// extracted by mini-css-extract-plugin
export default {"cartContainer":"cartcard_cartContainer__bjN6i","addItem":"cartcard_addItem__AGoRP","imageContainer":"cartcard_imageContainer__cuJje"};